module.exports = __webpack_public_path__ + "img/yml_thumbnail.c8a170a4.jpg";